<template>
  <div
    class="mac-title-bar flex items-center border-b-2 border-black bg-gray-300 px-1 py-0.5 cursor-default select-none touch-none"
    :class="{ 'cursor-grab': !dragging, 'cursor-grabbing': dragging }"
    @pointerdown="onPointerDown"
  >
    <!-- Close button - classic square -->
    <button
      type="button"
      class="mac-close-btn w-5 h-5 border-2 border-black bg-white flex-shrink-0 hover:bg-black transition-all duration-200 hover:scale-110 flex items-center justify-center"
      aria-label="Close"
      @pointerdown.stop
      @click.stop="$emit('close')"
    >
      <span class="text-sm font-bold leading-none text-black -mt-0.5 transition-colors">×</span>
    </button>
    <!-- Title stripes (classic Mac look) -->
    <div class="flex-1 flex items-center gap-0.5 ml-1 overflow-hidden">
      <div class="h-1 flex-1 min-w-0 bg-gray-400 border border-black rounded-none" />
      <span class="font-pixel text-lg font-bold px-2 truncate text-black whitespace-nowrap leading-none">{{ title }}</span>
      <div class="h-1 flex-1 min-w-0 bg-gray-400 border border-black rounded-none" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  dragging: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'drag-start'])

function onPointerDown(e) {
  if (e.pointerType === 'mouse' && e.button !== 0) return
  if (e.currentTarget && typeof e.currentTarget.setPointerCapture === 'function') {
    try {
      e.currentTarget.setPointerCapture(e.pointerId)
    } catch {
      // Ignore if capture not supported for this target.
    }
  }
  emit('drag-start', e)
}
</script>

<style scoped>
.mac-close-btn:hover span {
  color: white;
}
</style>
